/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'
import type { HotspotActionConfig } from './hotspotActionConfig'
import type { HotspotActionType } from './hotspotActionType'
import type { HotspotRect } from './hotspotRect'
import type { ScenarioHotspotAppearance } from './scenarioHotspotAppearance'

/**
 * 動画内のクリック領域（ホットスポット・ADR-0022）。
`appearance` が null なら、ボタンの見た目は動画に焼き込み、プレイヤーは透明なクリック領域だけを重ねる。
値があれば、プレイヤーがそのプリセットでボタンを描き、`label` をボタンの文字にする（ADR-0024）。
 */
export interface ScenarioHotspot {
  updatedAt: string
  createdAt: string
  /** 並び順（1始まり）。重なった場所では小さい方が優先 @example 1 */
  order: number
  /** @nullable */
  appearance: ScenarioHotspotAppearance
  actionConfig: HotspotActionConfig
  actionType: HotspotActionType
  rect: HotspotRect
  /** 表示終了（秒） @example 14 */
  endTime: number
  /** 表示開始（秒） @example 6 */
  startTime: number
  /** 計測・読み上げ用の名前 @example "仕事内容" */
  label: string
  nodeId: Cuid
  id: Cuid
}
